import React from "react";
import "./listloader.css";
import Global from "../../global";
//import ContentLoader from 'react-content-loader'

const CarouselContentLoader = (props) => {
  /*     <ContentLoader viewBox="0 0 1360 900"  backgroundColor={'var(--iq-rgba-body)'}
    foregroundColor={'var(--iq-rgba-second-body)'}>
    <rect x="30" y="20" rx="8" ry="8" width="200" height="200" />
    <rect x="30" y="250" rx="0" ry="0" width="200" height="18" />
    <rect x="30" y="275" rx="0" ry="0" width="120" height="20" />
    <rect x="250" y="20" rx="8" ry="8" width="200" height="200" />
    <rect x="250" y="250" rx="0" ry="0" width="200" height="18" />
    <rect x="250" y="275" rx="0" ry="0" width="120" height="20" />
    <rect x="470" y="20" rx="8" ry="8" width="200" height="200" />
    <rect x="470" y="250" rx="0" ry="0" width="200" height="18" />
    <rect x="470" y="275" rx="0" ry="0" width="120" height="20" />
    <rect x="690" y="20" rx="8" ry="8" width="200" height="200" />
    <rect x="690" y="250" rx="0" ry="0" width="200" height="18" />
    <rect x="690" y="275" rx="0" ry="0" width="120" height="20" />
    <rect x="910" y="20" rx="8" ry="8" width="200" height="200" />
    <rect x="910" y="250" rx="0" ry="0" width="200" height="18" />
    <rect x="910" y="275" rx="0" ry="0" width="120" height="20" />
    <rect x="1130" y="20" rx="8" ry="8" width="200" height="200" />
    <rect x="1130" y="250" rx="0" ry="0" width="200" height="18" />
    <rect x="1130" y="275" rx="0" ry="0" width="120" height="20" />
    <rect x="30" y="340" rx="8" ry="8" width="200" height="200" />
    <rect x="30" y="570" rx="0" ry="0" width="200" height="18" />
    <rect x="30" y="595" rx="0" ry="0" width="120" height="20" />
    <rect x="250" y="340" rx="8" ry="8" width="200" height="200" />
    <rect x="250" y="570" rx="0" ry="0" width="200" height="18" />
    <rect x="250" y="595" rx="0" ry="0" width="120" height="20" />
    <rect x="470" y="340" rx="8" ry="8" width="200" height="200" />
    <rect x="470" y="570" rx="0" ry="0" width="200" height="18" />
    <rect x="470" y="595" rx="0" ry="0" width="120" height="20" />
    <rect x="690" y="340" rx="8" ry="8" width="200" height="200" />
    <rect x="690" y="570" rx="0" ry="0" width="200" height="18" />
    <rect x="690" y="595" rx="0" ry="0" width="120" height="20" />
    <rect x="910" y="340" rx="8" ry="8" width="200" height="200" />
    <rect x="910" y="570" rx="0" ry="0" width="200" height="18" />
    <rect x="910" y="595" rx="0" ry="0" width="120" height="20" />
    <rect x="1130" y="340" rx="8" ry="8" width="200" height="200" />
    <rect x="1130" y="570" rx="0" ry="0" width="200" height="18" />
    <rect x="1130" y="595" rx="0" ry="0" width="120" height="20" />
  </ContentLoader> */
  if (Global.Loader === "Ripple") {
    return (
      <section
        className={Global.TYPE === "OTT" ? "content" : "content news-loader"}
        style={{ minHeight: "120px", paddingTop: "15%" }}
      >
        <div className="container-fluid">
          <div className="loaderWrapper">
            <div className="lds-ripple">
              <div></div>
              <div></div>
            </div>
          </div>
          <div className="loaderPara">
            {props.textLoader ? (
              <p className="text-center">{props.textLoader}</p>
            ) : (
              ""
            )}
          </div>
        </div>
      </section>
    );
  } else if (Global.Loader === "Hour Glass") {
    return (
      <section
        className={Global.TYPE === "OTT" ? "content" : "content news-loader"}
        style={{ minHeight: "120px", paddingTop: "15%" }}
      >
        <div className="container-fluid">
          {/* <div className="lowloader"></div> */}
          <div className="loaderWrapper">
            <div className="lds-hourglass"></div>
          </div>
          <div className="loaderPara">
            {props.textLoader ? (
              <p className="text-center">{props.textLoader}</p>
            ) : (
              ""
            )}
          </div>
        </div>
      </section>
    );
  } else if (Global.Loader === "Grid Line") {
    return (
      <section
        className={Global.TYPE === "OTT" ? "content" : "content news-loader"}
        style={{ minHeight: "120px", paddingTop: "15%" }}
      >
        <div className="container-fluid">
          <div className="loaderWrapper">
            <div className="lds-facebook">
              <div></div>
              <div></div>
              <div></div>
            </div>
          </div>
          <div className="loaderPara">
            {props.textLoader ? (
              <p className="text-center">{props.textLoader}</p>
            ) : (
              ""
            )}
          </div>
        </div>
      </section>
    );
  } else if (Global.Loader === "Ellipsis") {
    return (
      <section
        className={Global.TYPE === "OTT" ? "content" : "content news-loader"}
        style={{ minHeight: "120px", paddingTop: "15%" }}
      >
        <div className="container-fluid">
          <div className="loaderWrapper">
            <div className="lds-ellipsis">
              <div></div>
              <div></div>
              <div></div>
              <div></div>
            </div>
          </div>
          <div className="loaderPara">
            {props.textLoader ? (
              <p className="text-center">{props.textLoader}</p>
            ) : (
              ""
            )}
          </div>
        </div>
      </section>
    );
  } else if (Global.Loader === "Grid") {
    return (
      <section
        className={Global.TYPE === "OTT" ? "content" : "content news-loader"}
        style={{ minHeight: "120px", paddingTop: "15%" }}
      >
        <div className="container-fluid">
          <div className="loaderWrapper">
            <div className="lds-grid">
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
            </div>
          </div>
          <div className="loaderPara">
            {props.textLoader ? (
              <p className="text-center">{props.textLoader}</p>
            ) : (
              ""
            )}
          </div>
        </div>
      </section>
    );
  } else {
    return (
      <section
        className={Global.TYPE === "OTT" ? "content" : "content news-loader"}
        style={{ minHeight: "120px", paddingTop: "15%" }}
      >
        <div className="container-fluid">
          <div className="lowloader"></div>
        </div>
      </section>
    );
  }
};

export default CarouselContentLoader;
